<mat-progress-bar 
                  [class.visible]="(value$ | async) > 0 && (value$ | async) !== 100"
                  [value]="value$ | async"
                  class="progress-bar"
                  mode="indeterminate"></mat-progress-bar>
